document.addEventListener('DOMContentLoaded',function(){
  var toggle=document.querySelector('[data-menu-toggle]');
  var nav=document.querySelector('[data-mobile-nav]');
  var sticky=document.querySelector('[data-sticky-buy]');
  var offer=document.querySelector('#offre');
  var announcements=Array.prototype.slice.call(document.querySelectorAll('[data-announcement]'));
  var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function closeMenu(){
    if(!nav||!toggle)return;
    nav.classList.remove('open');
    toggle.setAttribute('aria-expanded','false');
    document.body.classList.remove('menu-open');
  }

  if(toggle&&nav){
    toggle.addEventListener('click',function(){
      var open=nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded',String(open));
      document.body.classList.toggle('menu-open',open);
    });
    nav.querySelectorAll('a').forEach(function(link){link.addEventListener('click',closeMenu);});
    document.addEventListener('keydown',function(event){if(event.key==='Escape')closeMenu();});
  }

  if(announcements.length>1&&!reduceMotion){
    var announcementIndex=0;
    window.setInterval(function(){
      announcements[announcementIndex].classList.remove('is-active');
      announcementIndex=(announcementIndex+1)%announcements.length;
      announcements[announcementIndex].classList.add('is-active');
    },4200);
  }

  // --- Apparition des sections ---
  // Un IntersectionObserver seul rate des sections lors d'un defilement rapide et
  // les laisse invisibles : le balayage synchrone sert de filet de securite.
  var reveals=Array.prototype.slice.call(document.querySelectorAll('.reveal'));
  var show=function(item){item.classList.add('is-visible');};

  if(reduceMotion||!('IntersectionObserver' in window)){
    reveals.forEach(show);
  }else{
    // marge d'anticipation : la section termine son fondu avant d'arriver a l'ecran,
    // sinon un defilement rapide la laisse pale et donne une impression de page vide.
    var AHEAD=1000;
    var pending=reveals.slice();
    var sweep=function(){
      if(!pending.length)return;
      var limit=window.innerHeight+AHEAD;
      pending=pending.filter(function(item){
        var box=item.getBoundingClientRect();
        if(box.top<limit&&box.bottom>-AHEAD){show(item);return false;}
        return true;
      });
      if(!pending.length){
        window.removeEventListener('scroll',sweep);
        window.removeEventListener('resize',sweep);
      }
    };
    var revealObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){show(entry.target);revealObserver.unobserve(entry.target);}
      });
    },{threshold:0,rootMargin:'1000px 0px 1000px 0px'});
    reveals.forEach(function(item){revealObserver.observe(item);});
    window.addEventListener('scroll',sweep,{passive:true});
    window.addEventListener('resize',sweep);
    sweep();
  }

  document.querySelectorAll('.faq-list details').forEach(function(item){
    item.addEventListener('toggle',function(){
      if(!item.open)return;
      document.querySelectorAll('.faq-list details[open]').forEach(function(other){if(other!==item)other.open=false;});
    });
  });

  var consent=document.querySelector('[data-digital-consent]');
  var consentCta=document.querySelector('[data-consent-cta]');
  if(consent&&consentCta){
    var updateConsent=function(){
      consentCta.classList.toggle('is-disabled',!consent.checked);
      consentCta.setAttribute('aria-disabled',String(!consent.checked));
    };
    consent.addEventListener('change',updateConsent);
    consentCta.addEventListener('click',function(event){
      if(!consent.checked){event.preventDefault();consent.focus();}
    });
    updateConsent();
  }

  var previewDialog=document.querySelector('[data-preview-dialog]');
  if(previewDialog){
    var previewImage=previewDialog.querySelector('[data-preview-image]');
    var previewCaption=previewDialog.querySelector('[data-preview-caption]');
    var previewClose=previewDialog.querySelector('[data-preview-close]');
    document.querySelectorAll('[data-preview-src]').forEach(function(card){
      card.addEventListener('click',function(){
        previewImage.src=card.getAttribute('data-preview-src');
        previewImage.alt=card.querySelector('img').alt;
        previewCaption.textContent=card.getAttribute('data-preview-title')||'';
        if(typeof previewDialog.showModal==='function')previewDialog.showModal();
      });
    });
    if(previewClose)previewClose.addEventListener('click',function(){previewDialog.close();});
    previewDialog.addEventListener('click',function(event){
      if(event.target===previewDialog)previewDialog.close();
    });
  }

  // Carrousels : apercus de l'outil et transformations avant / apres
  function setupCarousel(track,prev,next,dots,gap){
    if(!track||!prev||!next)return;
    var step=function(){
      var card=track.firstElementChild;
      return card?card.getBoundingClientRect().width+(gap||0):track.clientWidth;
    };
    var updateDots=function(){
      if(!dots||!dots.length)return;
      var index=Math.round(track.scrollLeft/Math.max(1,step()));
      dots.forEach(function(dot,dotIndex){dot.classList.toggle('is-active',dotIndex===index);});
    };
    next.addEventListener('click',function(){
      var atEnd=track.scrollLeft+track.clientWidth>=track.scrollWidth-8;
      track.scrollTo({left:atEnd?0:track.scrollLeft+step(),behavior:'smooth'});
    });
    prev.addEventListener('click',function(){
      var atStart=track.scrollLeft<=8;
      track.scrollTo({left:atStart?track.scrollWidth:track.scrollLeft-step(),behavior:'smooth'});
    });
    if(dots&&dots.length){
      dots.forEach(function(dot){
        dot.addEventListener('click',function(){
          track.scrollTo({left:Number(dot.getAttribute('data-carousel-dot'))*step(),behavior:'smooth'});
        });
      });
      track.addEventListener('scroll',updateDots,{passive:true});
      updateDots();
    }
  }

  setupCarousel(
    document.querySelector('[data-preview-track]'),
    document.querySelector('[data-carousel-prev]'),
    document.querySelector('[data-carousel-next]'),
    Array.prototype.slice.call(document.querySelectorAll('[data-carousel-dot]')),
    0
  );

  setupCarousel(
    document.querySelector('[data-ba-track]'),
    document.querySelector('[data-ba-prev]'),
    document.querySelector('[data-ba-next]'),
    null,
    22
  );

  if(sticky){
    var updateSticky=function(){
      if(window.innerWidth>640){sticky.classList.remove('is-visible');return;}
      var pastHero=window.scrollY>520;
      var offerVisible=offer&&offer.getBoundingClientRect().top<window.innerHeight*.8&&offer.getBoundingClientRect().bottom>120;
      sticky.classList.toggle('is-visible',pastHero&&!offerVisible);
    };
    window.addEventListener('scroll',updateSticky,{passive:true});
    window.addEventListener('resize',updateSticky);
    updateSticky();
  }
});
